export default "__VITE_ASSET__C0u68VQH__"